import React, { useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { createComment, createReplyComment } from '../../actions/commentActions'
import ModalMenu from '../../containers/ModalMenu';
import EmojiPicker from 'emoji-picker-react';
import ModalAudioPost from '../../containers/ModalAudioPost';
import ModalGif from '../../containers/ModalGif';
import { ReactComponent as DeleteIcon } from '../../img/ic_eliminar.svg';
import { ReactComponent as CloseIcon } from '../../img/ic_cerrar.svg';
import { ReactComponent as GaleryIcon } from '../../img/ic_galeria.svg';
import { ReactComponent as SendIcon } from '../../img/ic_enviar.svg';
import emojiImg from '../../img/emoticono.png'
import audioImg from '../../img/ic_audio_black.png'
import circle from '../../img/circulogris.png';
import { Translate } from '../../language';
import CommentNew from '../../containers/Post/CommentNew/CommentNew';
import localStorage from '../../utils/hooks/useLocalStorage';

const CreateNewComment = ({ noAdd,onSend,postID, isProfessional = false, isReplyComment }) => {
    const dispatch = useDispatch()
    const imgSelector = useRef();
    const [dataFile, setDataFile] = useState({})
    const [comment, setComment] = useState('')
    const [isOnlyGif, setIsOnlyGif] = useState(false)
    const [isOnlyAudio, setIsOnlyAudio] = useState(false)
    const [isShowAudio, setIsShowAudio] = useState(false)
    const [isShowGif, setIsShowGif] = useState(false)

    const sendComment = () => {
        
        if (dataFile) {
            const formData = new FormData();
            formData.append('text', comment)
            Object.values(dataFile).forEach(({ file }) => {
                console.log();
                if (file.type.includes('audio')) {
                    formData.append('audio', file)
                }
                if (file.type.includes('video')) {
                    formData.append('video', file)
                }
                if (file.type.includes('image')) {
                    formData.append('image', file)
                }
            });

            isReplyComment ?
                dispatch(createReplyComment(formData, postID, isProfessional))
                :
                dispatch(createComment(formData, postID, isProfessional,noAdd))
        }
        else {
            const formData = new FormData();
            formData.append('text', comment)
            isReplyComment ?
                dispatch(createReplyComment(formData, postID, isProfessional))
                :
                dispatch(createComment(formData, postID, isProfessional,noAdd))
        }
        setComment('')
        setDataFile({})
       // onSend()
    }

    const auto_height = (e) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }

    const onFileChange = (event) => {
        var filesTarget = event.target.files
        console.log()
        filesTarget[0].url = URL.createObjectURL(event.target.files[0])
        setDataFile({ [filesTarget[0].url]: { name: filesTarget[0].name, url: filesTarget[0].url, file: filesTarget[0] } })

    }

    const addEmoji = (event, code) => {
        setComment(comment + code.emoji)
    }

    const selectGif = (e) => {
        e.stopPropagation()
        setIsShowGif(!isShowGif)
    }

    const selectAudio = (e) => {
        e.stopPropagation()
        setIsShowAudio(!isShowAudio)
    }
    

    return (
        <CommentNew
        dataFile={dataFile}
        setDataFile={setDataFile}
            isReplyComment={isReplyComment}
            placeholder={Translate('addComment', 'es')}
            sendComment={sendComment}
            setComment={setComment}
            comment={comment}
        />
    )

    return (
        <div className="input-new-comment-post">
            {isProfessional ?
                localStorage().getItem("picturProfileProfesional") ?
                    <img alt="img" className="img-irn-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfileProfesional")}></img> :
                    <img alt="img" className="img-irn-profile mr-2" src={circle}></img>
                :
                localStorage().getItem("picturProfile") ?
                    <img alt="img" className="img-irn-profile mr-2" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                    <img alt="img" className="img-irn-profile mr-2" src={circle}></img>}

            <div className='input-new-container-comment'>
                <div className="column centerItems">
                    <textarea
                        onKeyPress={e => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault()
                                sendComment()
                            }
                        }}
                        className='textarea-comment'
                        rows="1"
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                        onInput={e => auto_height(e)}
                        name="comment"
                        type="text"
                        placeholder={Translate('addComment', 'es')} />
                    <div className="column centerItems endContent relative">
                        <ModalMenu
                            contentButton={
                                <img src={emojiImg} alt="img" style={{ height: '20px', width: '20px', cursor: 'pointer', marginTop: '5.5px', marginRight: '8px' }} />
                            }
                            contentModal={<div name="picker-emoji-new-post" className="emoji-picker-up emoji-picker-down-comment">
                                <EmojiPicker onEmojiClick={addEmoji} />
                            </div>}
                        />
                        <label className="column centerItems endContent">
                            {<input type="file" ref={imgSelector} onChange={(event) => { onFileChange(event) }} multiple accept=".png,.jpg,.jpeg,.gif,video/*,audio/*" />}
                            <GaleryIcon className="fill-parent mr-1" height="18" width="18" />
                        </label>
                        <img onClick={(e) => selectAudio(e)} alt="img" style={{ height: 18, width: 18, cursor: 'pointer' }} src={audioImg}></img>

                        <ModalAudioPost
                            setOnlyAudio={setIsOnlyAudio}
                            setData={setDataFile}
                            displayModal={isShowAudio}
                            closeModal={selectAudio}
                        />
                        <div onClick={(e) => selectGif(e)} className="Gif-icon-comment" >GIF</div>
                        <ModalGif
                            setOnlygif={setIsOnlyGif}
                            setData={setDataFile}
                            displayModal={isShowGif}
                            closeModal={selectGif}
                        />
                        <div onClick={() => {
                            sendComment()
                        }} className="send-comment-icon-float"><SendIcon className="cls-1 mr-1" height="25" width="25" /></div>
                    </div>
                </div>
                {console.log()}
                {dataFile && //Imagen previa
                    Object.values(dataFile)[0].file.type.includes('image') &&
                    <div className="commet-img-add-container">
                        <div onClick={() => { imgSelector.current.value = ""; setDataFile(null) }} className="close-modal-img-comment">
                            <CloseIcon className="cls-1" height="18" width="18" />
                        </div>
                        <img alt="img" className="comment-add-img" src={Object.values(dataFile)[0].url}></img>
                    </div>
                }
                {dataFile &&
                    Object.values(dataFile)[0].file.type.includes('audio') &&
                    <div className="commet-img-add-container">
                        <div onClick={() => setDataFile(null)} className="close-modal-img-comment">
                            <CloseIcon className="cls-1" height="18" width="18" />
                        </div>
                        <div className="commet-audio-add-container">
                            <audio controlsList="nodownload" controls>
                                <source src={Object.values(dataFile)[0].url}></source>
                            </audio>
                        </div>
                    </div>
                }
                {dataFile &&
                    Object.values(dataFile)[0].file.type.includes('video') &&
                    <div className="commet-img-add-container">
                        <div onClick={() => setDataFile(null)} className="close-modal-img-comment">
                            <CloseIcon className="cls-1" height="18" width="18" />
                        </div>
                        <div className="commet-audio-add-container">
                            <video preload="auto" className="video-post-view" controls>
                                <source src={Object.values(dataFile)[0].url}></source>
                            </video>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CreateNewComment
